import { compose, withProps } from 'recompose';
import { injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';
import { connect } from 'react-redux';

import { selectUpcomingListCounter } from '../../../redux/surveys/selectors';
import styles from '../index.styl';

const mapStateToProps = state => ({
  upcomingListCounter: selectUpcomingListCounter(state),
});

export const enhance = compose(
  injectIntl,
  connect(mapStateToProps),
  withProps(({ intl: { formatMessage } }) => ({ formatMessage })),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/Surveys/SurveyList/enhance.js